import { useQuery } from 'react-query';
import { fetchTvAiringToday } from '../services/api';

export const useTvAiringToday = options => {
  return useQuery('tvAiringToday', fetchTvAiringToday, options);
};
